import { graphql } from '@/gql';
import type { DefaultTipInput } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export type UpdateCallerTipGourmetVariables = {
  callerId: string;
  defaultTip: DefaultTipInput;
};

export const updateCallerTipGourmet = async ({ callerId, defaultTip }: UpdateCallerTipGourmetVariables) => {
  const response = await mutationExecute({
    variables: {
      callerId,
      defaultTip,
    },
    mutation: graphql(`
      mutation UpdateCallerTipGourmet($callerId: String!, $defaultTip: DefaultTipInput!) {
        updateCallerTipGourmet(callerId: $callerId, defaultTip: $defaultTip)
      }
    `),
  });

  return response.data?.updateCallerTipGourmet;
};
